import { useState } from "react";
import { useEffect } from "react";
import { X } from "lucide-react";
import Header from "./Header";
import RefreshAppModal, { useRefreshPrompt } from "./RefreshAppModal";
import { useAuth } from "@/contexts/AuthContext";

const UAT_DISMISS_KEY = "vgws_pref_uat_dismissed";

function UatBanner({ user, version }) {
  const [hidden, setHidden] = useState(false);
  // Re-evaluate dismissal once we know the actual server version.
  useEffect(() => {
    if (!version) return;
    try {
      setHidden(localStorage.getItem(UAT_DISMISS_KEY) === version);
    } catch {}
  }, [version]);
  if (hidden || user?.role !== "super_admin") return null;
  const onDismiss = () => {
    try { localStorage.setItem(UAT_DISMISS_KEY, version || "phase-2c"); } catch {}
    setHidden(true);
  };
  return (
    <div className="bg-[#2d6b6b] text-white text-xs sm:text-sm px-4 py-2 flex items-center justify-between gap-2"
         data-testid="uat-banner">
      <div className="flex items-center gap-2">
        <span className="uppercase tracking-widest font-semibold">UAT Mode</span>
        <span className="opacity-80">Test data cleared. Version {version || "phase-2c"}</span>
      </div>
      <button onClick={onDismiss} className="p-1 rounded hover:bg-white/10" aria-label="Dismiss" data-testid="uat-banner-dismiss">
        <X size={14} />
      </button>
    </div>
  );
}

export default function Layout({ children }) {
  const { user } = useAuth();
  const { open, latest, closeModal, openModal } = useRefreshPrompt();
  return (
    <div className="min-h-screen bg-paper" data-testid="app-layout">
      <UatBanner user={user} version={latest} />
      <Header onOpenRefresh={openModal} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {children}
      </main>
      <RefreshAppModal open={open} latestVersion={latest} onClose={closeModal} />
    </div>
  );
}
